// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import 'react-datepicker/dist/react-datepicker.css';

import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form, Formik } from 'formik';
import S from './styles';
import ErrorImg from '../../../assets/images/pic_error_internet.svg';
import PlantImage from '../assets/plant-success.png';
import { isValidPassword } from '../../../lib/validation';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';

type Status = 'success' | 'fail' | null

const ResetPasswordCardForm = (): JSX.Element => {
  const intl = useIntl();
  const [status, setStatus] = useState<Status>()
  const history = useHistory();
  const close = () => {
    history.push('/member')
  }

  if (status === 'success' || status === 'fail') {
    return (
      <S.Container>
        <S.Card>
          <S.CloseButton onClick={close} />
          <S.ResultImg src={status === 'success' ? PlantImage : ErrorImg} alt="" />
          <S.ResultTitle>{status === 'success' ? intl.formatMessage({ id: 'G022' }) : intl.formatMessage({ id: 'G025' })}</S.ResultTitle>
          <S.ResultDescription>
            {status === 'success' ? intl.formatMessage({ id: 'G023' }) : intl.formatMessage({ id: 'G026' })}
          </S.ResultDescription>
          {status === 'success' ?
            <S.ResultButton onClick={close}><FormattedMessage id="G024" /></S.ResultButton> :
            <S.ResultButton onClick={() => { history.goBack() }}><FormattedMessage id="G027" /></S.ResultButton>
          }
        </S.Card>
      </S.Container>
    )
  }

  return (
    <S.Container>
      <Formik
        enableReinitialize
        initialValues={{
          password: '',
          newPassword: '',
        }}
        validate={(values) => {
          const errors: { [prop: string]: any } = {};

          if (!values.password) {
            errors.password = 'G015';
          } else if (!isValidPassword(values.password)) {
            errors.password = 'G017';
          }

          if (!values.newPassword) {
            errors.newPassword = 'G016';
          } else if (!isValidPassword(values.newPassword)) {
            errors.newPassword = 'G020'
          } else if (values.password === values.newPassword) {
            errors.newPassword = 'G021'
          }

          return errors;
        }}
        onSubmit={async ({ password, newPassword }, { setSubmitting, setFieldError, resetForm }) => {
          setSubmitting(true);
          try {
            const user = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(user, password, newPassword)
            resetForm();
            setStatus('success');
          } catch (error) {
            console.log({ error });
            if (error.code === 'NotAuthorizedException') {
              setFieldError('password', 'G019');
            } else {
              setFieldError('password', error.message);
              setStatus('fail')
            }
          }
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
        }) => {
          const intl = useIntl();
          const passwordError = errors.password ? '*' + intl.formatMessage({ id: errors.password }) : undefined;
          const newPasswordError = errors.newPassword ? '*' + intl.formatMessage({ id: errors.newPassword }) : undefined;

          return (
            <S.Card as={Form}>
              <S.CloseButton onClick={close} />
              <S.Form>
                <S.FormTitleWrapper>
                  <S.FormTitle>
                    <FormattedMessage id="G013" />
                  </S.FormTitle>
                  <S.FormSubtitle>
                    <FormattedMessage id="G014" />
                  </S.FormSubtitle>
                </S.FormTitleWrapper>
                <S.PasswordInput
                  label={intl.formatMessage({ id: 'G030' })}
                  placeholder={intl.formatMessage({ id: 'G015' })}
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  error={passwordError}
                  touched={touched.password}
                />
                <S.PasswordInput
                  label={intl.formatMessage({ id: 'G031' })}
                  placeholder={intl.formatMessage({ id: 'G016' })}
                  name="newPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.newPassword}
                  error={newPasswordError}
                  touched={touched.newPassword}
                />
                {!errors.newPassword && <S.NotePasswordRule><FormattedMessage id="G017" /></S.NotePasswordRule>}
              </S.Form>
              <S.SubmitButton ><FormattedMessage id="G018" /></S.SubmitButton>
            </S.Card>
          )
        }}
      </Formik>
    </S.Container>
  )
}

export { ResetPasswordCardForm as default };
